import { RequireOnly } from '@pelicargo/types';
import { Markup } from '@prisma/client';

import { INLAND_FREIGHT_SERVICES } from '../../constants/constraints';
import { MarkupKind } from '../../constants/markups';

/** Whether a markup is the Air or the Inland kind, read from what it applies to */
export const kind = (markup: RequireOnly<Markup, 'applicable_freight_services'>): MarkupKind | undefined => {
  const services = markup.applicable_freight_services ?? [];
  if (services.some((service) => INLAND_FREIGHT_SERVICES.includes(service))) return 'INLAND';
  if (services.length) return 'AIR';
  return undefined;
};
